<template>
  <div :class="['tw-w-full tw-rounded-full tw-bg-gray-300 tw-relative tw-overflow-hidden', {'tw-h-4': props.height == 'small'}, {'tw-h-10': props.height != 'small'}]">
    <div :class="['tw-rounded-full tw-bg-orange-medium tw-absolute tw-transition-all', {'tw-h-4': props.height == 'small'}, {'tw-h-10': props.height != 'small'}]" :style="{width: progressWidth}"></div>
    <div :class="[' tw-rounded-left-full tw-bg-gray-600 tw-absolute tw-transition-all tw-z-10', {'tw-h-4': props.height == 'small'}, {'tw-h-10': props.height != 'small'}]" :style="{width: baselineWidth}"></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  percentage: Number,
  baseline: Number,
  height: String,
})

const baselineWidth = computed(() => {
  if (props.baseline != null) {
    return ((props.baseline).toString() + "%");
  } else {
    return '0%'
  }
})

const progressWidth = computed(() => {
  if (props.percentage != null) {
    if (props.baseline != null) {
       return ((props.percentage + props.baseline).toString() + "%"); 
    } else {
      return ((props.percentage).toString() + "%");
    }
  } else {
    return '0%'
  }
})

</script>